module.exports = __webpack_public_path__ + "img/fred.ff8ca16d.jpg";